import { produce } from 'immer';
import { useContext } from 'react';
import Icons from '../../../../../../common/widgets/Icons';
import PopoverDialog from '../../../../../../common/widgets/PopoverDialog';
import { config } from '../../../../config';
import { CustomerInfoContext } from '../../../../contexts/CustomerInfoContext';
import { PlatformInfoContext } from '../../../../contexts/PlatformInfoContext';
import { customerService } from '../../../../services/customer';
import { LanguageMenu } from '../LanguageMenu';

export default function Language() {
  const { customerInfo, setCustomerInfo } = useContext(CustomerInfoContext);
  const platformInfo = useContext(PlatformInfoContext);

  const onLanguageChange = async (lang: string) => {
    const currentLang = customerInfo?.languageCode ?? config.defaultLanguage;

    if (lang != currentLang) {
      window.localStorage.setItem('language', lang);

      const result = await customerService.updateLanguage(lang);

      if (!result.hasErrors) {
        setCustomerInfo(
          produce(customerInfo, d => {
            d.languageCode = lang;
          }),
        );
        location.reload();
      }
    }
  };

  return (
    <>
      <PopoverDialog
        className="dropdown-menu-list"
        placement="bottom"
        closeFromContent
        type="hover"
        content={<LanguageMenu onLanguageChange={onLanguageChange} />}
      >
        <a
          className="btn app-bar-tools-btn app-bar-language"
          onClick={() => {
            const languages = platformInfo?.languages ?? config.languages;
            const lang = languages.find(
              l => l != (customerInfo?.languageCode ?? config.defaultLanguage),
            );
            if (lang) {
              onLanguageChange(lang);
            }
          }}
        >
          <span className="btn-icon">
            <Icons.Language />
          </span>
          <span className="btn-text">
            {(
              customerInfo?.languageCode ?? config.defaultLanguage
            )?.toUpperCase()}
          </span>
        </a>
      </PopoverDialog>
    </>
  );
}
